import formErrors from "../tools/formErrors";
import formCalltouchWidgetErrors from "../tools/formCalltouchWidgetErrors";

/**
 * Форма перезвоните мне
 *
 */
$.fn.callbackForm = function () {
    const SUCCESS_COOKIE_NAME = 'callback_form_success';

    const $self = $(this);
    const $form = $self.find('.js-call-request-form');
    const $nameInput = $form.find('input[name="name"]');
    const $phoneInput = $form.find('input[name="phone"]');
    const $reasonSelect = $self.find('.js-custom-reason-select');
    const $timeSelect = $self.find('.js-custom-time-select');
    const $dateSelect = $self.find('.js-custom-date-select');
    const $acceptCheckbox = $form.find('.js-accept-policy');
    const $sendRequestButton = $self.find('.js-send-call-request');
    const hasSuccessBlock = $self.data('success-block');

    let select2Defaults = {
        minimumResultsForSearch: -1,
        containerCss: {
            'width': '100%'
        },
        dropdownCssClass: 'callback-select-dropdown'
    };

    const setSuccessCookie = () => {
        let newCookie = `${encodeURIComponent(SUCCESS_COOKIE_NAME)}=${encodeURIComponent('1')}`

        newCookie += `;max-age=${60*60*24}` // устанавливаем куку на сутки
        newCookie += `;path=/`;

        document.cookie = newCookie;
    };

    const checkCookie = (name) => {
        var matches = document.cookie.match(new RegExp(
            "(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + "=([^;]*)"
        ));

        return matches ? decodeURIComponent(matches[1]) : 0;
    };

    const proccesSuccessSubmitFormWithAnalyticGoals = () => {
        if (checkCookie(SUCCESS_COOKIE_NAME)) {
            return;
        }

        try {
            ym(1491705,'reachGoal','callback');
            console.log(`Send YM goal - callback`);
        } catch (e) {
            console.log(e)
        }

        try {
            // gtag('event','Send',{'event_category':'Form','event_label':'callback'});
            // console.log(`Send qtag goal - callback`);
        } catch (e) {
            console.log(e);
        }

        setSuccessCookie();
    };

    /**
     * Очищаем поля
     */
    const clearField = function () {
        $self.find('.js-cleared-field').val('');
    };

    /**
     * Функция обработчик сабмита
     */
    const submitHandler = function () {
        $.ajax({
            method: 'POST',
            url: $form.attr('action'),
            data: $form.serialize()
        }).done(function(data) {
            if (data.success) {
                showSuccessBlock();
                proccesSuccessSubmitFormWithAnalyticGoals();
                addDataLayer();
            } else {
                formErrors($form.get(0), data.errors);
            }

            $sendRequestButton.prop('disabled', false);
        }).fail(function (error) {
            console.log(error);
        });
    }

    const CalltouchErrorTypes = {
        VALIDATION_ERROR: 'validationError',
        API_ERROR: 'apiError',
    }

    const CalltouchApiErrorCodes = {
        LIMIT_TIMEOUT_PHONE_OR_SESSION: 10007,
        LIMIT_ONE_PHONE: 10006,
    };

    const clearFormErrors = () => {
        $form.get(0).querySelectorAll('.form-group').forEach(function (formGroup) {
            formGroup.classList.remove('has-error');
        });
    }

    // Добавление данных об успешной заявки в window.dataLayer - запрос CEO
    const addDataLayer = () => {
        // if (!window.dataLayer || !Array.isArray(window.dataLayer)) {
        //     window.dataLayer = [];
        // }
        //
        // const eCategory = getCategoryByTypeForm();
        //
        // window.dataLayer.push({
        //     'eCategory': eCategory,
        //     'eAction': 'sentForm',
        //     'event': 'GTMForms'
        // });
    };

    /**
     * Функция обработчик сабмита для коллтача
     */
    const submitHandlerWithCalltouch = function () {
        const data = transformDataForCalltouch();

        clearFormErrors();

        $.ajax({
            method: 'POST',
            url: '/api/calltouch',
            data: data,
            headers: {"Content-type": "application/json"}
        }).done(function() {
            showSuccessBlock();
            proccesSuccessSubmitFormWithAnalyticGoals();
            addDataLayer();
        }).fail(function (error) {
            const data = error.responseJSON?.data;

            if (!data) {
                formCalltouchWidgetErrors($form.get(0), [
                    {
                        fieldPath: 'phone',
                        message: 'Произошла ошибка. Пожалуйста, повторите позже.',
                    }
                ]);
            }

            if (data.type === CalltouchErrorTypes.VALIDATION_ERROR) {
                formCalltouchWidgetErrors($form.get(0), error.responseJSON.data.validationErrorData.violations);
            }

            if (data.type === CalltouchErrorTypes.API_ERROR
                && data.apiErrorData) {
                let errorMessage = '';

                if (data.apiErrorData.errorCode === CalltouchApiErrorCodes.LIMIT_TIMEOUT_PHONE_OR_SESSION) {
                    errorMessage = 'Вы можете отправить не более 1-ой заявки в течение 5 минут.';
                }

                if (data.apiErrorData.errorCode === CalltouchApiErrorCodes.LIMIT_ONE_PHONE) {
                    errorMessage = 'Вы можете отправить не более 3-х заявок в течение 30 минут';
                }

                formCalltouchWidgetErrors($form.get(0), [
                    {
                        fieldPath: 'phone',
                        message: errorMessage,
                    }
                ]);
            }
        });
        $sendRequestButton.prop('disabled', false);
    }


    /**
     * Собираем дату заявки
     * Сервис принимает дату в формате Y-m-d H:i:s (Например 2018-01-01 13:00:32)
     * @returns {string}
     */
    const getScheduleTime = function () {
        const date = new Date();
        let day = transformDate(date.getDate());
        let month = transformDate(date.getMonth() + 1);
        let year = date.getFullYear();
        let hours = transformDate(date.getHours());
        let minutes = transformDate(date.getMinutes());
        let seconds = transformDate(date.getSeconds());

        const hasTime = $self.find('.js-time-block').hasClass('active');
        let scheduleTime = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;

        if (hasTime) {
            const timeSelected = $timeSelect.find(':selected').text();
            const dateTime = timeSelected.split(':')[0].length > 1 ? `${timeSelected}:00` : `0${timeSelected}:00`;
            const dateSelected =  $dateSelect.find(':selected').text();

            const dateYear = dateSelected.length
                ? dateSelected.split('.').reverse().join('-') // Получаем дату в формате 13.01.2023 - сплитим и переворачиваем
                : `${year}-${month}-${day}`;

            scheduleTime = `${dateYear} ${dateTime}`;
        }

        return scheduleTime;
    };

    /**
     * Преобразуем данные для запроса в коллтач
     */
    const transformDataForCalltouch = function () {
        const ROUTE_KEY = 'nrmed-form';
        const phoneValue = $form.find('input[name=phone]').val().replace(/[\D]+/g, ''); //очищаем номер телефона от символов
        const nameValue = $form.find('input[name=name]').val();
        const selectedReason = $form.find('input[name=selected_reason]').val();
        let additionalFields = [
            {"name": "Причина", "value": selectedReason},
        ];
        //делаем проверку, чтобы валидатор виджета не ругался, так как имя не обязательное поле
        if (nameValue) {
            additionalFields.push({"name": "Имя", "value": nameValue});
        }

        let scheduleTime = getScheduleTime();

        const requestData = JSON.stringify({
            "routeKey": ROUTE_KEY,
            "phone": phoneValue,
            "fields": additionalFields,
            "scheduleTime": scheduleTime,
        });

        return requestData;
    }

    /**
     * Преобразуем дату
     */
    const transformDate = function(number) {
        return number < 10 ? `0${number}` : number;
    }

    /**
     * Показываем блок успеха
     */
    const showSuccessBlock = function () {
        if (hasSuccessBlock){
            $self.addClass('show-success');
            setTimeout(() => {
                $self.removeClass('show-success');
                clearField();
            }, 5000);
        } else {
            $self.empty().append([
                $('<div>', {
                    class: 'callback-form__title',
                    text: 'Ваша заявка отправлена'
                }),
                $('<p>', {
                    class: 'callback-form__text',
                    text: 'Наш менеджер перезвонит вам в указанное время'
                }),
                $('<button>', {
                    type: 'button',
                    class: 'btn btn-blue js-close-popup',
                    text: 'Закрыть'
                })
            ]);
        }
    }

    /**
     * Антиспам с помощью reCAPTCHA v3 от Google
     * @returns {Promise<*>}
     */
    const verifyRecaptchaV3 = async function () {
        const {success = false} = await $.ajax({
            type: 'POST',
            url: '/verify',
            dataType: 'json',
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            },
            data: {
                'g-recaptcha-response': getReCaptchaV3Response('feedback_ajax_id')
            },
            success: function (data) {
                refreshReCaptchaV3('feedback_ajax_id', 'feedback');
                if (data.success) {
                    return true;
                } else {
                    formErrors($form.get(0), data.errors);
                    return false;
                }
            },
            error: function (err) {
                refreshReCaptchaV3('feedback_ajax_id', 'feedback');
                return false;
            }
        })

        return success;
    }

    /**
     * Отправляем запрос обратного звонка в коллтач или через laravel
     * @param {Boolean} withCalltouch - отправить запрос в коллтач или нет
     */
    const sendRequestCallback = function (withCalltouch = false) {
        const data = transformDataForCalltouch();
        const log = JSON.parse(data);

        $.ajax({
            type: 'POST',
            url: '/calltouchLog',
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            },
            data: JSON.stringify({
                ...log,
                url: window.location.href,
            }),
            dataType: 'json',
        })

        if (withCalltouch) {
            submitHandlerWithCalltouch();
        } else {
            submitHandler();
        }
    }

    /**
     * Получить нужную категорию по типу форму
     * @returns {string}
     */
    const getCategoryByTypeForm = function () {
        const type = $self.data('type') ?? 'callback';
        console.log(type)
        switch (type) {
            case 'questions':
                return 'ostalis_voprosy';
            default:
                return 'callback'
        }
    }

    /**
     * Инициализация поля выбора даты звонка
     */
    $dateSelect.each(function () {

        function formateItems (item) {
            if (parseInt(item.id) === 1) {
                return item.text  = 'Сегодня';
            } else if (parseInt(item.id) === 2) {
                return item.text  = 'Завтра';
            } else {
                return item.text;
            }
        }

        $(this).select2($.extend({}, select2Defaults, {
            templateResult: formateItems,
            placeholder: {
                id: '0',
                text: 'Сегодня'
            },
            dropdownParent: $(this).closest('.form-group'),
            dropdownCssClass: 'callback-select-dropdown callback-select-dropdown--time'
        }));
    });

    /**
     * Инициализация поля выбора времени звонка
     */
    $timeSelect.each(function () {
        $(this).select2($.extend({}, select2Defaults, {
            dropdownParent: $(this).closest('.form-group'),
            dropdownCssClass: 'callback-select-dropdown callback-select-dropdown--time'
        }));
    });

    /**
     * Инициализация кастомного скролла в поле выбора времени звонка
     */
    $timeSelect.on('select2:open', function (e) {
        const $list = $(this).closest('.form-group').find('ul');
        tools.initCustomScroll($list);
        tools.updateCustomScroll($list);
    });

    /**
     * Сброс кастомного скролла при закрытии поля выбора времени звонка
     */
    $timeSelect.on('select2:close', function (e) {
        tools.destroyCustomScroll($(this).closest('.form-group').find('ul'));
    });

    /**
     * Инициализация кастомного скролла в поле выбора даты звонка
     */
    $dateSelect.on('select2:open', function (e) {
        tools.initCustomScroll($(this).closest('.form-group').find('ul'));
    });

    /**
     * Сброс кастомного скролла при закрытии поля выбора даты звонка
     */
    $dateSelect.on('select2:close', function (e) {
        const $list = $(this).closest('.form-group').find('ul');
        tools.destroyCustomScroll($list);
    });

    /**
     * Обработка переключателя выбора времени взонка (Сейчас / выбрать время)
     */
    $self.find('.js-show-time').each(function () {
        $(this).on('change', function () {
            if ($(this).prop('checked') === true && $(this).data('val') === 'show') {
                $(this).closest('.js-callback-form').find('.js-time-block').addClass('active');
            } else {
                $(this).closest('.js-callback-form').find('.js-time-block').removeClass('active');
            }

        });
    });

    /**
     * Обработка отправки формы
     */
    $form.on('submit', function (e) {
        e.preventDefault();
        // $sendRequestButton.prop('disabled', true);
        const withCalltouch = $self.data('with-calltouch');
        const recaptchaV3 = $self.data('recaptcha-v3');

        if (recaptchaV3) {
            verifyRecaptchaV3().then((result) => {
                if (result) {
                    sendRequestCallback(withCalltouch);
                }
            });
        } else {
            sendRequestCallback(withCalltouch);
        }
    });

    return this;
};

/**
 * Инициализация плагина
 */
$('.js-callback-form').each( function () {
    if ($(this).length) {
        $(this).callbackForm();
    }
});

